import axios from "axios";

export const api = axios.create({
    // Use the environment variable for baseURL, default to localhost if not set
    // baseURL: process.env.REACT_APP_API_BASE_URL_PROD,
    //baseURL: process.env.REACT_APP_API_BASE_URL_DEV,
    //baseURL: process.env.REACT_APP_API_BASE_URL_QA,
    baseURL: process.env.REACT_APP_API_BASE_URL_PROD_LATEST || "https://api.goodnews.meantr.com"
});

api.interceptors.request.use(
    (config) => {
        const authToken = localStorage.getItem("authtoken");
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

